var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExecutedTrips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.565,
    height: 115.697,
    viewBox: "0 0 104.565 115.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "executed_trips",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10120",
    "data-name": "Group 10120",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12000",
    "data-name": "Path 12000",
    d: "M31.97,0A18.569,18.569,0,0,0,13.42,18.55a18.317,18.317,0,0,0,7.139,14.579,15.633,15.633,0,0,0,3.469,2.212A18.948,18.948,0,0,0,31.97,37.1a18.55,18.55,0,1,0,0-37.1Zm2.715,28.906a10.674,10.674,0,0,1-13.071-7.692,20.171,20.171,0,0,1-.352-2.514.763.763,0,1,1,1.508-.05,9.183,9.183,0,0,0,18.047,2.312A9.087,9.087,0,0,0,34.584,9.753a8.987,8.987,0,0,0-7.34.955c-.05,0-.1.05-.151.1-.05,0-.05,0-.05.1h.4a.764.764,0,0,1,.7.754.73.73,0,0,1-.7.754H25.033a.716.716,0,0,1-.7-.8V9.451a.769.769,0,0,1,.754-.855.753.753,0,0,1,.754.8v.352c.3-.2.553-.352.8-.5a10.71,10.71,0,1,1,8.043,19.656Zm-9.6-10.356a6.887,6.887,0,1,1,6.837,6.887,6.9,6.9,0,0,1-6.837-6.887Zm9.8,1.961a.805.805,0,0,0-.3-1.156,18.186,18.186,0,0,1-1.609-1.106.436.436,0,0,1-.251-.352V14.83a.76.76,0,1,0-1.508,0V18.4a.9.9,0,0,0,.4.855l2.111,1.357a.793.793,0,0,0,1.156-.1Z",
    transform: "translate(54.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12001",
    "data-name": "Path 12001",
    d: "M95.365,57.78c0-4.625-2.162-8.094-6.083-10.557a3.348,3.348,0,0,1-1.408-1.709c-1.961-6.183-3.821-12.467-5.63-18.7A24.754,24.754,0,0,1,61.281,4.342a7.247,7.247,0,0,0-2.162-.3H36.3c-4.022,0-6.485,2.413-6.485,6.485v5.429H25.94c-6.234,0-10.507,3.268-12.266,9.25C11.663,32.041,9.6,38.828,7.49,45.665a2.393,2.393,0,0,1-1.106,1.408A12.1,12.1,0,0,0,0,58.233V80.855a7.343,7.343,0,0,0,.151,1.81c.654,3.067,2.765,4.524,5.831,4.927,0,1.961-.05,3.921,0,5.831a5.922,5.922,0,0,0,5.932,5.982c1.709.05,3.418,0,5.077,0,4.575,0,6.837-2.312,6.887-6.887V87.541H71.536v5.882a5.964,5.964,0,0,0,5.982,5.982c1.86.05,3.77,0,5.63,0a5.99,5.99,0,0,0,6.284-6.284V87.692c4.726-1.257,5.982-2.865,5.982-7.692,0-7.39,0-14.83-.05-22.22ZM23.326,34.4c.553-1.759,1.207-3.469,1.609-5.279.251-1.056.7-1.257,1.709-1.257H68.822c.955,0,1.357.2,1.609,1.207,1.609,5.48,3.318,10.959,5.027,16.64H20.008Q21.667,39.984,23.326,34.4Zm.5,38.156A5.954,5.954,0,0,1,17.9,66.578,5.879,5.879,0,0,1,23.879,60.7a5.932,5.932,0,1,1-.05,11.864Zm47.657,0a5.933,5.933,0,1,1,6.033-5.882A5.986,5.986,0,0,1,71.486,72.56Z",
    transform: "translate(0 16.27)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutedTrips);
export default __webpack_public_path__ + "static/media/executed_trips.416adf3889dc5690e1d7c93d7a2e2eae.svg";
export { ForwardRef as ReactComponent };